import axios from "axios";
import { urls } from "../config/appConfig";
import registerAuthInterceptor from "./auth.interceptor";

const instance = axios.create({
  baseURL: urls.apiBaseUrl,
});

registerAuthInterceptor(instance);

export default instance;
